var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 1.05C12.481 1.05 12.95 1.519 12.95 2.1V11.9C12.95 12.481 12.481 12.95 11.9 12.95H2.1C1.519 12.95 1.05 12.481 1.05 11.9V2.1C1.05 1.519 1.519 1.05 2.1 1.05H11.9ZM11.9 0H2.1C0.938 0 0 0.938 0 2.1V11.9C0 13.062 0.938 14 2.1 14H11.9C13.062 14 14 13.062 14 11.9V2.1C14 0.938 13.062 0 11.9 0Z",
    fill: "#D60B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99985 11.0258C6.71285 11.0258 6.47485 10.7878 6.47485 10.5008V4.20078C6.47485 3.91378 6.71285 3.67578 6.99985 3.67578C7.28685 3.67578 7.52485 3.91378 7.52485 4.20078V10.5008C7.52485 10.7878 7.28685 11.0258 6.99985 11.0258Z",
    fill: "#D60B52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19993 11.0258C3.91293 11.0258 3.67493 10.7878 3.67493 10.5008V7.70078C3.67493 7.41378 3.91293 7.17578 4.19993 7.17578C4.48693 7.17578 4.72493 7.41378 4.72493 7.70078V10.5008C4.72493 10.7878 4.48693 11.0258 4.19993 11.0258Z",
    fill: "#D60B52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80015 11.0244C9.51315 11.0244 9.27515 10.7864 9.27515 10.4994V6.29941C9.27515 6.01241 9.51315 5.77441 9.80015 5.77441C10.0871 5.77441 10.3251 6.01241 10.3251 6.29941V10.4994C10.3251 10.7864 10.0871 11.0244 9.80015 11.0244Z",
    fill: "#D60B52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.f1f1516cae827a7df60756e20cbfc9e3.svg";
export { ForwardRef as ReactComponent };